export default __webpack_public_path__ + "static/media/Bracers of the Kozak Slayer.241312d5.jpg";